import React, {useState} from 'react';
import RiseSurveyInterstitialControls from 'screens/InsomniaSurvey/components/RiseSurveyControls/RiseSurveyInterstitialControls';
import {surveyInstance} from 'screens/InsomniaSurvey/InsomniaSurvey';
import {SurveyData} from 'screens/InsomniaSurvey/utils/surveyData';
import Analytics from 'utils/Analytics';
import {getSleepioInfoContent, SleepioInfoCard, SleepioInfoScreen} from './SleepioInfoInterstitial';
import styles from './SleepioRxInterstitials.module.css';

type Choice = {value: string; text: string};

type Props = {
  questionName: string;
  title: string;
  description?: string;
  choices: Choice[];
  scienceScreen: SleepioInfoScreen;
};

/**
 * Fit question + its "What the science says" reveal on ONE screen (RET-2564):
 * the user answers the agree/disagree, the science content fades in below, and
 * Continue (disabled until answered) advances. Replaces the old radioPage +
 * separate science-interstitial pairs. The answer is persisted to survey data
 * under questionName, exactly as the radioPage did.
 */
export const SleepioFitWithScienceInterstitial: React.FC<Props> = ({
  questionName,
  title,
  description,
  choices,
  scienceScreen,
}) => {
  const [answer, setAnswer] = useState<string | undefined>(
    () => (surveyInstance.getValue(questionName) as string | undefined) ?? undefined,
  );

  const handleSelect = (value: string) => {
    setAnswer(value);
    surveyInstance.setValue(questionName, value);
    SurveyData.save(surveyInstance);
    Analytics.track('SleepioRx Fit Answer Selected', {question: questionName, value});
  };

  const science = getSleepioInfoContent(scienceScreen);

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>{title}</h1>
      {description ? <p className={styles.body}>{description}</p> : null}
      <div className={styles.optionList}>
        {choices.map(choice => (
          <button
            key={choice.value}
            type="button"
            className={`${styles.optionButton} ${answer === choice.value ? styles.optionButtonSelected : ''}`}
            onClick={() => handleSelect(choice.value)}
          >
            {choice.text}
          </button>
        ))}
      </div>
      {answer ? (
        <div className={styles.scienceReveal}>
          <SleepioInfoCard content={science} />
        </div>
      ) : null}
      <RiseSurveyInterstitialControls continueButtonTitle="Continue" variant="purple" disabled={!answer} />
    </div>
  );
};

export default SleepioFitWithScienceInterstitial;
